import React from "react";
import {GoalsService} from "./api/server_calls";

class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                width:"80%",
                //margin:"auto"
            },
            ident: "slider",
            val: this.props.endline,
            vision: this.props.vis
        }
    }

    componentDidMount() {
        // console.log(document.querySelector(".slider input").clientWidth);
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.num !== this.state.val) {
            this.setState({
                val: nextProps.endline,
                vision: nextProps.vis
            });
        }
    }

    handleResponse = (res, obj) => {
        this.props.func(res, obj);
    }

    handleChange = () => {
        var obj = {
            'country': document.querySelector("select").value,
            'Policy': document.getElementsByTagName("input")[0].value,
            'PPFP': document.getElementsByTagName("input")[6].value,
            'LARC': document.getElementsByTagName("input")[2].value,
            'CHW': document.getElementsByTagName("input")[3].value,
            'MobileOutreach': document.getElementsByTagName("input")[4].value,
            'Pharma': document.getElementsByTagName("input")[5].value,
            'Stockout': document.getElementsByTagName("input")[1].value,
            'Comprehensive': document.getElementsByTagName("input")[7].value,
            'SBC': document.getElementsByTagName("input")[8].value,
            'MassMedia': document.getElementsByTagName("input")[9].value
        };
        GoalsService.changeResults(parseInt(obj['country']), parseFloat(obj['Policy']), parseFloat(obj['PPFP']), parseFloat(obj['LARC']), parseFloat(obj['CHW']), parseFloat(obj['MobileOutreach']), parseFloat(obj['Pharma']), parseFloat(obj['Stockout']), parseFloat(obj['Comprehensive']), parseFloat(obj['SBC']), parseFloat(obj['MassMedia']), (result) => this.handleResponse(result, obj));
    }

    render() {
        var colour = "black";
        if (parseInt(this.state.val) < parseInt(this.props.baseline)) {
            colour = "red";
        } else {
            colour = "black";
        }
        let base = (this.props.baseline * 4 / 5) + "%";
        // let base = (this.props.baseline / 100 * this.props.factor) + "px";
        let push = (this.state.val * this.props.factor / 100 - 10) + "px";
        //let push = (4/5 * this.state.val) + "%";
        let header = this.props.heading.split(" -!*!*!- ");
        return (
            <div className={this.state.ident}>
                <p className="attn" style={{marginBottom:"65px"}}><cite>Measure: </cite>{header[0]}
                    <br />
                    <i className="slider_source" style={{display:this.state.vision === "none" ? "block" : "none"}}>{header[1]}</i>
                    <i className="slider_source" style={{display:this.state.vision}}>Note: no baseline data available</i>
                </p>
                <span>0%</span>
                <span>100%</span>
                <div className="guidewire" style={{width:"1px", float:"left", position:"relative", marginLeft:"2%", left:base}}>
                    <h6>Baseline</h6>
                    <h6>{this.props.baseline + "%"}</h6>
                    <div className="tickmark" style={{height:"35px", width:"5px", background:"blue", position:"relative"}}></div>
                </div>
                <input type="range" min="0" max="100" value={this.state.val} step="1" onChange={(e) => this.setState({val: e.target.value})} onMouseUp={() => this.handleChange()} style={this.state.style} />
                <div className="guidewire" style={{width:"1px", float:"left", position:"relative", marginLeft:"2%", left:push}}>
                    <h6>Endline</h6>
                    <h6><b style={{color:colour}}>{this.state.val}%</b></h6>
                </div>


            </div>
        )
    }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/slider.js